<template>
  <div>
    <h1>Summary Document Data</h1>
    <hr>
    <!-- FILTER START -->
    <panel class="border border-secondary" :noExpand="true">
      <template slot="header">
        <h4 class="panel-title">Filter Option</h4>
      </template>
      <div class="outerBox filterBox">
        <div class="row" style="min-height:80px">
          <div class="col-12 " >
            <div class="row">
              <div class="col-md-4 col-12 form-group" style="height:42px" >
                <label>Filter By</label>
                <MultiSelect
                  class="mt-1"
                  :options="options.filter_by.map(x => x.value)"
                  :custom-label="opt => options.filter_by.find(x => x.value == opt).name"
                  v-model="filter.filter_by"
                  />
              </div>
              <div class="col-md-4 col-12 form-group" style="height:42px" >
                <label>Month</label>
                <MultiSelect
                  class="mt-1"
                  :options="options.month"
                  v-model="selected.month"
                  label="name"
                  track-by="value"
                />
              </div>
              <div class="col-md-4 col-12 form-group" style="height:42px" >
                <label>Year</label>
                <MultiSelect
                  class="mt-1"
                  :options="options.year"
                  v-model="filter.year"
                  />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2 mt-3">
            <button class="w-100 btn btn-primary" type="button" @click="fetchData()">Filter</button>
          </div>
          <div class="col-md-2 mt-3">
            <button class="w-100 btn btn-success" type="button" @click="downloadExcel()">
              <span class="fa fa-file-excel"></span>&nbsp;&nbsp;Export To Excel
            </button>
          </div>
        </div>
      </div>
    </panel>
    <!-- FILTER END -->

    
    <table class="table text-center">
      <thead>
        <tr style="background-color:black;color:white">
          <th>Date</th>
          <th>SIPB</th>
          <th>SLAHM</th>
          <th>SLD</th>
		      <th>SPG</th>
          <th>Invoice</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(datum, index) in data" :key="index">
          <td>{{datum.date}}</td>
          <td>{{numberWithCommas(datum.sipb)}}</td>
          <td>{{numberWithCommas(datum.slahm)}}</td>
          <td>{{numberWithCommas(datum.sld)}}</td>
          <td>{{numberWithCommas(datum.spg)}}</td>
          <td>{{numberWithCommas(datum.invoice)}}</td>
        </tr>
        <tr>
          <td><b>Total</b></td>
          <td>{{numberWithCommas(dataTotal.sipb)}}</td>
          <td>{{numberWithCommas(dataTotal.slahm)}}</td>
          <td>{{numberWithCommas(dataTotal.sld)}}</td>
          <td>{{numberWithCommas(dataTotal.spg)}}</td>
          <td>{{numberWithCommas(dataTotal.invoice)}}</td>
        </tr>
      </tbody>
    </table>

  </div>
</template>

<script>
  import MultiSelect from 'vue-multiselect'
  import flatPickr from 'vue-flatpickr-component'
  import moment, { months } from 'moment'
  const XLSX = require('xlsx')

  export default {
    data () {
      return {
        options : {
          month : [],
          year : [],
          filter_by : [{
            name : 'Tanggal Penerimaan Data',
            value : 'created_at'
          },{
            name : 'Tanggal Dokumen',
            value : 'document_date'
          }]
		    },
        selected : {
          month:  {
            name: moment().format("MMMM"),
            value: moment().format("M")
          },
        },
        filter: {
          month: new moment().format("M"),
          year:  new moment().format("Y"),
          filter_by : 'created_at'
        },
        data : [],
        dataTotal : {
          date : 'Total',
          sipb : 0,
          slahm : 0,
          sld : 0,
          spg : 0,
          invoice : 0
        }
      }
    },
    components : {
      flatPickr,
      MultiSelect
    },
    mounted () {
      this.getFilterOptions()
      this.fetchData()
    },
    watch : {
      selected : {
        handler () {
          this.filter.month = this.selected.month.value;
        },
        deep : true,
      }
    },
    methods : {
		downloadExcel () {
			let data = JSON.parse(JSON.stringify(this.data))

			data.push(this.dataTotal)

			let exportFileName = 'Summary Document Data.xls'
			let wb = XLSX.utils.book_new()
			var ws = XLSX.utils.json_to_sheet(data, {raw:true});
			XLSX.utils.book_append_sheet(wb, ws, 'Data')
			XLSX.writeFile(wb, exportFileName)
		},
      	calculateTotals () {
			this.dataTotal = {
				date : 'Total',
				sipb : 0,
				slahm : 0,
				sld : 0,
        spg : 0,
        invoice : 0
			}

			for(var i = 0 ;  this.data.length ; i++) {
			this.dataTotal.sipb += parseInt(this.data[i].sipb)
			this.dataTotal.slahm += parseInt(this.data[i].slahm)
			this.dataTotal.sld += parseInt(this.data[i].sld)
      this.dataTotal.spg += parseInt(this.data[i].spg)
      this.dataTotal.invoice += parseInt(this.data[i].spg)
			}
		},
      	getFilterOptions () {
			this.options.month = this.$store.getters.getMonth;
			this.options.year = this.$store.getters.getYear;
		},
      	async fetchData () {
			///summary/data-document
			this.$http.get('/api/reports/summary/data-document?' + await this.initialiseFilter())
			.then((resp)=>{
				this.data = resp.data.data
			})
			.then(() => {
			this.calculateTotals()
			})
			.catch((err)=>{
			console.log(err);
			})
		},
      	initialiseFilter(){
			if(!(typeof this.filter === 'object' && this.filter !== null)){
			this.filterUrl = '';
			return;
			}
			var keys = Object.keys(this.filter);
			let stringUrl = '';
			var queryParams = this.filter;

			for(var i = 0 ; i < keys.length; i++){
			if(!queryParams[keys[i]])
				continue;

			if(queryParams[keys[i]] == '' || queryParams[keys[i]].length == 0)
				continue 

			if((keys[i] == 'user_type') && queryParams[keys[i]] == 'All')
				continue;
			
			// if(keys[i] == 'start_hour' || keys[i] == 'end_hour')
			//   queryParams[keys[i]] += ":00";

			stringUrl += `&${keys[i]}=${queryParams[keys[i]]}`;
			
			}
			
			return stringUrl;
     	 },
    }
  }
</script>

<style scoped>
  .modal-mask {
      position: fixed;
      z-index: 1020;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, .5);
      display: table;
      transition: opacity .3s ease;
  }

  .modal-wrapper {
      display: table-cell;
      vertical-align: middle;
  }

  .modal-container {
      width: 100%;
      margin: 0px auto;
      padding: 20px 30px;
      background-color: #fff;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
      transition: all .3s ease;
      font-family: Helvetica, Arial, sans-serif;
  }

  .modal-header h3 {
      margin-top: 0;
      color: #42b983;
  }

  .modal-body {
      margin: 20px 0;
  }

  .modal-default-button {
      float: right;
  }

  /*
  * The following styles are auto-applied to elements with
  * transition="modal" when their visibility is toggled
  * by Vue.js.
  *
  * You can easily play with the modal transition by editing
  * these styles.
  */

  .modal-enter {
      opacity: 0;
  }

  .modal-leave-active {
      opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
      -webkit-transform: scale(1.1);
      transform: scale(1.1);
  }

  /* MODAL STARTS */
  .modal-body{
      margin:0
  }

  .modal-body .moduleLine{
      margin-bottom: 0vh;
  }

  .modal-body .moduleLine a{
      text-decoration: none;
  }

  .modal-body .moduleLine .moduleBox:hover{
      background-color: #E0E0E0;
      transition: background-color 0.7s ease;
      color: #212121;
      transition: color 0.7s ease;
  }

  .modal-body .moduleLine .moduleBox{
      border:1px solid #BDBDBD;
      border-radius: 20px;
      padding: 20px 0;
      color:black;
      margin-bottom: 3vh;
  }

  .modal-body .moduleLine .moduleBox i{
      font-size:5vh;
  }

  h3.modalHeadline{
      margin:0 0 20px 0;
      font-weight: bold;
      text-align : center;
  }
  /* MODAL ENDS */
</style>
